import { makeAutoObservable } from "mobx"
import PopupsManager from "react-sdk/PopupsManager"
import AppState, { POPUPS } from "./AppState"
import SequenceScenario from "./SequenceScenario"

class Vues {
    all = {}

    init(vues) {
        vues.forEach(v => {
            if (v.id) {
                if (this.all[v.id] !== undefined) {
                    window.alert("Careful, some vues have the same id (" + v.id + "), check your vues.data file")
                }
                this.all[v.id] = v
            }
        })
        makeAutoObservable(this)
    }

    get(id) {
        return this.all[id]
    }

    show(id) {
        var v  = this.all[id]

        if(!v) {
            window.alert("Id (" + id + ") doesn't exist in the loaded vues")
        }
        else {
            PopupsManager.open(POPUPS.LOCATION, v, () => { })
        }
    }

}

export default new Vues()